export const TYPES = {
  SET_KYC_ALL: "kyc/SET_KYC_ALL",
  SET_KYC_OPEN_ADD: "kyc/SET_KYC_OPEN_ADD",
  SET_KYC_OPEN_EDIT: "kyc/SET_KYC_OPEN_EDIT",
  SET_KYC_SELECTED: "kyc/SET_KYC_SELECTED",
  SET_KYC_SEARCH: "kyc/SET_KYC_SEARCH",
  //
  SET_KYC_STEP: "kyc/SET_KYC_STEP",
  SET_KYC_OPEN_CONTRACT: "kyc/SET_KYC_OPEN_CONTRACT",
};
